import {colors} from '../colors';

export const theme = {
    colors: {
        primary: colors.PRIMARY,
        secondary: colors.SECONDARY,
        tertiary: colors.TERTIARY,
        background: colors.BACKGROUND,
        backgroundLight: colors.BACKGROUND2,
        red: colors.RED,
        green: colors.GREEN
    }
}